import React, { memo } from 'react';
import PropTypes from 'prop-types';
import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import duration from 'dayjs/plugin/duration';

import RequestAccessModal from 'containers/Managers/RequestAccessModal';

dayjs.extend(utc);
dayjs.extend(duration);

const RequestAccess = ({ targetProfile, isModalOpen, onClose, agency }) => {
  if (!isModalOpen) return null;

  return (
    <RequestAccessModal isOpen={isModalOpen} targetProfile={targetProfile} agencyDetails={agency} onClose={onClose} />
  );
};

RequestAccess.propTypes = {
  targetProfile: PropTypes.object,
  isModalOpen: PropTypes.bool,
  onClose: PropTypes.func,
  agency: PropTypes.object,
};

export default memo(RequestAccess);
